import  DashBoardFunction  from "../../Navigation/DashMenus";

const DashMenus = DashBoardFunction();

const navConfig = [...DashMenus];

export default navConfig;
